import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import { UserProvider } from './context/UserContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import BulkUpload from './pages/BulkUpload';
import HistoryPage from './pages/HistoryPage';
import CustomerHistory from './pages/CustomerHistory';
import OpenEye from './pages/OpenEye';
import UserManagement from './pages/UserManagement';
import TokenManagement from './components/tokens/TokenManagement';

// Force rebuild - API Token Management
export default function App() {
  return (
    <BrowserRouter>
      <UserProvider>
      {/* Toast Container must be rendered once in your app (usually at root) */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored" // Optional: try "dark" or "light"
      />
      
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/bulk-upload" element={<BulkUpload />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/history/:customerId" element={<CustomerHistory />} />
        <Route path="/openeye" element={<OpenEye />} />
        <Route path="/users" element={<UserManagement />} />
        <Route path="/tokens" element={<TokenManagement />} />
        <Route path="/token-management" element={<TokenManagement />} />
        <Route path="/api-tokens" element={<TokenManagement />} />
      </Routes>
      </UserProvider>
    </BrowserRouter>
  );
}